import LocationsLayout from './LocationsLayout';
export default LocationsLayout;
